import { getAPIService, postAPIService } from "./BaseServce";

export const getTwoFactorStatus = async () => {
  const res = await getAPIService("/auth/2fa/status");
  return res.data as { enabled: boolean };
};

export const setupTwoFactor = async () => {
  const res = await postAPIService("/auth/2fa/setup");
  return res.data as { provisioning_uri: string; secret: string };
};

export const verifyTwoFactorSetup = async (otp: string) => {
  const res = await postAPIService("/auth/2fa/verify-setup", { otp });
  return res.data as { recovery_codes: string[] };
};

export const disableTwoFactor = async (password: string, otp: string) => {
  const res = await postAPIService("/auth/2fa/disable", { password, otp });
  return res.data as { detail: string };
};

export const verifyLoginOtp = async (preAuthToken: string, otp: string) => {
  const res = await postAPIService("/auth/login/verify-otp", {
    pre_auth_token: preAuthToken,
    otp,
  });
  return res.data;
};
